package world.phantasmal.webui.controllers

import world.phantasmal.webui.DisposableContainer

abstract class Controller : DisposableContainer()
